<div class="cabecalho">
  <app-steps [current]="stepAtual()" [total]="totalSteps()"></app-steps>
  <h2 class="title">Anexe os documentos necessários</h2>
</div>

<div class="documentos">
  <p class="formatos">Formatos aceitos: <span>.PDF, .PNG e .JPEG</span></p>
  <div class="lista-documentos">
    @for (doc of documentos(); track doc.tipoDocumento) {
      <app-upload-doc-modal
        [documento]="doc"
        [processed]="doc.travado"
        [withError]="doc.semArquivo"
        [removivel]="doc.removivel"
        [centralizarNaAreaVisivel]="true"
        (saveDoc)="onArquivoDocumento($event)"
        (removeDoc)="onRemoverDocumento($event)"
        (click)="onTentativaUpload(doc.tipoDocumento)"
        (keydown.enter)="onTentativaUpload(doc.tipoDocumento)"
        (keydown.space)="onTentativaUpload(doc.tipoDocumento)"
      ></app-upload-doc-modal>
    }
  </div>
</div>

<div class="d-flex justify-content-center align-items-center buttons-requerimento">
  <vivest-button variant="outline" size="md" (click)="onReturn()">
    Voltar
  </vivest-button>
  <vivest-button variant="primary" size="md" [disabled]="!podeContinuar()" (click)="onSubmit()">
    <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
    {{ reenvio() ? 'Concluir reenvio' : 'Continuar para resumo' }}
  </vivest-button>
</div>
